export default "__VITE_ASSET__Byxfqs9A__"